import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { CTAButton } from './ui/CTAButton';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { comparisonRows } from '../data/sections';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
export function ComparisonTable() {
  return <section id="comparacion" className="border-t border-mp-border bg-mp-dark py-20 md:py-24 scroll-mt-20" data-id="element-67" data-mp="3ic8v3ub767iy">
      <Container data-id="element-68" data-mp="3mdkbrac3fif0">
        <div className="overflow-x-auto rounded-2xl border border-mp-border" data-id="element-69" data-mp="3me3uuudhccum">
          <table className="w-full min-w-[520px] border-collapse text-left" data-id="element-70" data-mp="38eb81a52qgrx">
            <thead data-id="element-71" data-mp="38g5lk3e0n6lz">
              <tr className="bg-mp-card" data-id="element-72" data-mp="3dcvxceisfg1l">
                <th className="px-5 py-4 font-heading text-xs uppercase tracking-wide text-mp-gray md:text-sm" data-id="element-73" data-mp="3dbujy3eauhgp">
                  Incluye
                </th>
                <th className="px-5 py-4 text-center font-heading text-xs uppercase tracking-wide text-mp-white md:text-sm" data-id="element-74" data-mp="21xpgrclwubmf">
                  Base
                </th>
                <th className="px-5 py-4 text-center font-heading text-xs uppercase tracking-wide text-mp-lime md:text-sm" data-id="element-75" data-mp="2dzi2jtcabxak">
                  Kit de Ejecución
                </th>
              </tr>
            </thead>
            <tbody data-id="element-76" data-mp="2iwi7g0xeeu03">
              {comparisonRows.map((row, i) => <tr key={row.feature} className={i % 2 === 0 ? 'bg-mp-black/40' : 'bg-transparent'} data-id="element-77" data-mp="2iv75m6nijwbm" data-mpi={i}>
                  <td className="border-t border-mp-border px-5 py-3.5 text-sm text-mp-white md:text-[15px]" data-id="element-78" data-mp="2wughiu4os49s">
                    {row.feature}
                  </td>
                  <td className="border-t border-mp-border px-5 py-3.5 text-center" data-id="element-79" data-mp="36l1gwjs6pctr">
                    {row.base ? <CheckIcon className="mx-auto h-4 w-4 text-mp-white" strokeWidth={2.5} data-id="element-80" data-mp="31nje7b4rftu7" /> : <MinusIcon className="mx-auto h-4 w-4 text-mp-gray/50" strokeWidth={2.5} data-id="element-81" data-mp="3ghwduy8t755x" />}
                  </td>
                  <td className="border-t border-mp-border px-5 py-3.5 text-center" data-id="element-82" data-mp="3ip5gbhsmah21">
                    {row.kit ? <CheckIcon className="mx-auto h-4 w-4 text-mp-lime" strokeWidth={2.5} data-id="element-83" data-mp="3no8np8w2kzd6" /> : <MinusIcon className="mx-auto h-4 w-4 text-mp-gray/50" strokeWidth={2.5} data-id="element-84" data-mp="3sl8trjsx624a" />}
                  </td>
                </tr>)}
              <tr className="bg-mp-card" data-id="element-85" data-mp="6678lwjnoqbn">
                <td className="border-t border-mp-border px-5 py-4 font-heading text-sm uppercase text-mp-white md:text-base" data-id="element-86" data-mp="69bj1bnpsiar">
                  Precio
                </td>
                <td className="border-t border-mp-border px-5 py-4 text-center font-heading text-lg text-mp-white md:text-xl" data-id="element-87" data-mp="f8gj4mexcjp1">
                  17,90 €
                </td>
                <td className="border-t border-mp-border px-5 py-4 text-center font-heading text-lg text-mp-lime md:text-xl" data-id="element-88" data-mp="2h01yyxtgfmtn">
                  23,90 €
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center" data-id="element-89" data-mp="2egovj9d7hpms">
          <p className="font-heading text-lg uppercase text-mp-white sm:text-xl" data-id="element-90" data-mp="29nly2q5b5w1b">
            Por solo 6 € más añades las dos herramientas de ejecución.
          </p>

          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-91" data-mp="1zppq277o3h7f">
            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" size="md" fullWidthMobile data-id="element-92" data-mp="1znv3ypkntj1r">
              Quiero la versión base — 17,90 €
            </CTAButton>
            <CTAButton href={KIT_CHECKOUT_URL} size="lg" showArrow fullWidthMobile data-id="element-93" data-mp="2sewo7537m4s5">
              Quiero todo por 23,90 €
            </CTAButton>
          </div>
          <GuaranteeLine className="mt-4" data-id="element-94" data-mp="2igpacv47w2ud" />
        </div>
      </Container>
    </section>;
}